<template>
  <div class="studio-events-preview">
    <h1 class="mb-4">
      {{ data.title }}
    </h1>
    <CompactEventsList :events="limitedEvents" />
    <div v-if="remainingEventsLength > 0" class="mt-2">
      <router-link
        class="undecorated-router-link"
        :to="{ name: 'studio-product-events' }"
      >
        <i class="fa fa-calendar-o c-brand-color mr-2"></i>
        {{
          $tc('PRODUCTS.LABELS.MORE_EVENTS_VARIANT', remainingEventsLength, {
            remainingEventsLength,
          })
        }}
      </router-link>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CompactEventsList from '@/web/components/events/CompactEventsList';

export default Vue.extend({
  name: 'StudioEventsPreview',
  components: {
    CompactEventsList,
  },
  props: {
    limit: {
      type: Number,
      default: 3,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
    }),
    events() {
      return this.product.events;
    },
    limitedEvents() {
      if (!this.events) return [];
      return this.events.slice(0, this.limit);
    },
    remainingEventsLength() {
      return Math.max(0, this.events.length - this.limit);
    },
  },
});
</script>
